<template>
  <div class="userinfoshow">
    <user-title :msg="msg" />
    <user-info-show @cNowindex="cNowindex" />
  </div>
</template>

<script>
import UserInfoShow from "./UserInfoShow.vue";
import UserTitle from "./UserTitle.vue";
export default {
  data() {
    return {
      msg: "用户信息"
    };
  },
  components: { UserInfoShow, UserTitle },
  methods: {
    cNowindex(val) {
      this.$emit("nowindex", val);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/user/UserInfo.vue